import { IBusStopLayout, IBusStopLayoutInfo } from "./busStopLayout.types";

export class BusStopLayoutInfo implements IBusStopLayoutInfo {
  readonly lineTurnUid: string;
  readonly lineStationUid: string;
  readonly lineStationName: string;
  readonly arrivalTime: string;
  readonly departureTime: string;
  readonly order: number;
  readonly onYn: boolean;
  readonly offYn: boolean;
  readonly returnYn: boolean;
  readonly coreYn: boolean;
  readonly transYn: boolean;
  readonly beginYn: boolean;
  readonly finalYn: boolean;
  readonly endYn: boolean;
  readonly gateNo: string[];
  readonly campusCode: string;
  readonly campusName: string;
  readonly layoutList: IBusStopLayout[][][];

  constructor(data: IBusStopLayoutInfo) {
    this.lineTurnUid = data.lineTurnUid;
    this.lineStationUid = data.lineStationUid;
    this.lineStationName = data.lineStationName;
    this.arrivalTime = data.arrivalTime;
    this.departureTime = data.departureTime;
    this.order = data.order;
    this.onYn = data.onYn;
    this.offYn = data.offYn;
    this.returnYn = data.returnYn;
    this.coreYn = data.coreYn;
    this.transYn = data.transYn;
    this.beginYn = data.beginYn;
    this.finalYn = data.finalYn;
    this.endYn = data.endYn;
    this.gateNo = data.gateNo;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
    this.layoutList = data.layoutList;
  }
}
